import { render } from "./PersonComponent.vue?vue&type=template&id=58418bd4&scoped=true"
const script = {}

import "./PersonComponent.vue?vue&type=style&index=0&id=58418bd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58418bd4"]])

export default __exports__